import { combineReducers } from 'redux';
import {
  CAN_TOUCH,
  CHANGE_STATE,
  MAXIMIZE_GUIDE,
  MINIMIZE_GUIDE,
  SHOW_AUTHENTICATION_DIALOG,
  HIDE_AUTHENTICATION_DIALOG,
} from '../actions/types';

export const GUIDE_SIZES = {
  MAXIMIZED: 'MAX',
  MINIMIZED: 'MIN',
};

export const UI_STATES = {
  CONTROLS: 'CONTROLS',
  IDLE: 'IDLE',
};

const canTouch = (state = false, action) => {
  switch (action.type) {
    case CAN_TOUCH:
      return true;
    default:
      return state;
  }
};

const state = (currentState = UI_STATES.CONTROLS, action) => {
  switch (action.type) {
    case CHANGE_STATE:
      return action.payload;
    default:
      return currentState;
  }
};

const guideSize = (currentSize = GUIDE_SIZES.MINIMIZED, action) => {
  switch (action.type) {
    case MAXIMIZE_GUIDE:
      return GUIDE_SIZES.MAXIMIZED;
    case MINIMIZE_GUIDE:
      return GUIDE_SIZES.MINIMIZED;
    default:
      return currentSize;
  }
};

const showAuthenticationDialog = (currentState = false, action) => {
  switch (action.type) {
    case SHOW_AUTHENTICATION_DIALOG:
      return true;
    case HIDE_AUTHENTICATION_DIALOG:
      return false;
    default:
      return currentState;
  }
};

export const uiReducer = combineReducers({
  canTouch,
  guideSize,
  state,
  showAuthenticationDialog,
});
